// export const baseUrl = 'https://abarishr.hennainternational.in/api'

export const baseUrl = 'https://abarishr.hennainternational.in/api'

export const cloudinaryBaseUrl = 'https://abarishr.hennainternational.in/api/cloudinary/'